export const GET_USER_FETCH_REQUESTED = 'GET_USER_FETCH_REQUESTED'
export const GET_USER_FETCH_SUCCESS = 'GET_USER_FETCH_SUCCESS'
export const SAVE_USER_FETCH_REQUESTED = 'SAVE_USER_FETCH_REQUESTED'
export const SAVE_USER_FETCH_SUCCESS = 'SAVE_USER_FETCH_SUCCESS'
export const UPDATE_USER_IMAGE_FETCH_REQUESTED = 'UPDATE_USER_IMAGE_FETCH_REQUESTED'
export const UPDATE_USER_IMAGE_FETCH_SUCCESS = 'UPDATE_USER_IMAGE_FETCH_SUCCESS'
export const CHANGE_PASSWORD_FETCH_REQUESTED = 'CHANGE_PASSWORD_FETCH_REQUESTED'
export const CHANGE_PASSWORD_FETCH_SUCCESS = 'CHANGE_PASSWORD_FETCH_SUCCESS'
